import React from 'react'

import TeacherSignUpForm from './TeacherSignUpForm'
import getStrings from 'getStrings'
import { Switch, Route, Redirect } from 'react-router-dom'
import TeacherSignUpSuccess from './TeacherSignUpSuccess'

const TeacherSignUpExplanation = (props) => {
    const strings = getStrings()
    
    return (
        <div className='schoolzone-signup'>
            <div className='container flex-row'>
                <Switch>
                    <Route exact path="/schoolzone/teacher/signup" component={TeacherSignUpForm} />
                    <Route exact path="/schoolzone/teacher/signup-success" component={TeacherSignUpSuccess} />
                    <Route path="/schoolzone/teacher/*">
                        <Redirect to="/schoolzone/teacher/signup" />
                    </Route>
                    <Route exact path="/schoolzone/teacher">
                        <Redirect to="/schoolzone/teacher/signup" />
                    </Route>
                </Switch>
                <div>
                    <h1 className='text-white bg-orange rounded-border-2 padding-left-2 padding-right-2 padding-top-1 padding-bottom-1 inline-block'>{strings.TEACHER_LOUNGE_EXPLANATION_HEADER}</h1>
                    <div className='explanation-wrap margin-bottom-2'>
                        <p>{strings.TEACHER_LOUNGE_EXPLANATION_PARAGRAPH_2}</p>
                        <p>{strings.TEACHER_LOUNGE_EXPLANATION_PARAGRAPH_3}</p>
                        <p>{strings.TEACHER_LOUNGE_EXPLANATION_PARAGRAPH_4}</p>
                    </div>
                    <h1 className='padding-left-2'>{strings.TEACHER_LOUNGE_BENEFITS_HEADER}</h1>
                    <ul className='padding-left-2'>
                        <li>- {strings.TEACHER_LOUNGE_BENEFITS_1}</li>
                        <li>- {strings.TEACHER_LOUNGE_BENEFITS_2}</li>
                        <li>- {strings.TEACHER_LOUNGE_BENEFITS_4}</li>
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default TeacherSignUpExplanation